import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=67547cb5&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
